export const getInitials = (contact) => {
  const name = String(contact || "").trim();
  if (!name) {
      return "?";
  }

  const hasLetters = /[A-Za-z]/.test(name);
  if (!hasLetters) {
    return name.slice(0, 2);
  }
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};


export const capitalizeName = (value = "") =>
  value
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());